import { Big } from "big.js";
import { t } from "i18next";
import { useState } from "react";

import BigStar from "@/assets/icons/big-star.svg?react";
import { Button } from "@/components/Button";
import { useAirdrops, useStore, useTokens } from "@/hooks/store";
import { displayAmount, formatMonetaryAmount } from "@/utils";

import styles from "./styles";
import { SheetModal } from "../index";
import { SheetDescription, SheetTitle } from "../styles";

export const useAirdropClaimedModal = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<{ airdropId: number; numberOfNfts: number } | null>(null);

  const network = useStore((store) => store.network);
  const getTokenById = useTokens((store) => store.getTokenById);
  const airdrops = useAirdrops((store) => store.airdrops[network]);

  const currentAirdrop = data ? airdrops[data.airdropId] : null;
  const token = currentAirdrop ? getTokenById(network, currentAirdrop.token_id) : null;

  const openModal = (id: number, numberOfNfts: number) => {
    setData({ airdropId: id, numberOfNfts });
    setOpen(true);
  };

  const closeModal = () => {
    setData(null);
    setOpen(false);
  };

  const claimedAmount =
    data && currentAirdrop ? Big(currentAirdrop.claim_amount_by_person).mul(data.numberOfNfts).toFixed() : "0";

  const modal =
    currentAirdrop && token ? (
      <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
        <styles.Container>
          <BigStar />
          <SheetTitle>{t("Modals.Airdrop.Congrats")}</SheetTitle>
          <styles.Body>
            <SheetDescription>{t("Modals.Airdrop.YouHaveSuccessfullyClaimed")}</SheetDescription>
            <styles.Text>
              <div>
                <styles.Amount>
                  {formatMonetaryAmount(displayAmount(claimedAmount, token.metadata.decimals))}
                </styles.Amount>
                <styles.Image>
                  <img src={token.metadata.icon} />
                </styles.Image>
              </div>
              <styles.Symbol>{token.metadata.symbol}</styles.Symbol>
            </styles.Text>
          </styles.Body>
          <styles.Footer>
            <Button type="black" name="Close" handler={closeModal} />
          </styles.Footer>
        </styles.Container>
      </SheetModal>
    ) : (
      <></>
    );

  return { isOpen, openModal, closeModal, modal };
};
